import React, { useEffect, useState } from 'react';
import { FILTER_QUERY_BUILDER_TABS } from '_constants/old/filters';
import { QueryBuilderContainer } from 'modules/Modals/old/FilterModal/components/QueryBuilderContainer';
import { IsVaAccount, HasAccess, IsAzAccount, IsMdAccount } from 'modules';
import Location from 'modules/Modals/FilterPages/Location';
import { PERMISSIONS } from '_constants';
import { getCorporation } from '_entities/Filters/Filters.actions';
import { getRetailerCorporationOptions } from '_entities/Filters/Filters.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'ui-kit';
import VisitsHistory from '../RetailersBuilderSections/VisitsHistory';
import RetailerCharacteristics from '../RetailersBuilderSections/RetailerCharacteristics';
import * as Styled from './styles';

const TABS = [
  {
    id: 1,
    title: FILTER_QUERY_BUILDER_TABS.LOCATION,
  },
  {
    id: 2,
    title: FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS,
  },
  {
    id: 3,
    title: FILTER_QUERY_BUILDER_TABS.VISITS_HISTORY,
  },
];

export const RetailersQueryBuilder = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const corporationOptions = useSelector(getRetailerCorporationOptions);
  const isAzAccount = IsAzAccount();
  const isVaAccount = IsVaAccount();
  const isMdAccount = IsMdAccount();
  const hasResidentialModule = HasAccess(PERMISSIONS.RESIDENTIAL_LOCATION);
  const dispatch = useDispatch();

  useEffect(() => {
    (async function getDataForCorporation() {
      try {
        await dispatch(getCorporation());
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const displayContent = () => {
    switch (activeTab) {
      case FILTER_QUERY_BUILDER_TABS.LOCATION:
        return <Location />;
      case FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS:
        return (
          <RetailerCharacteristics
            isVaAccount={isVaAccount}
            isResidential={hasResidentialModule}
            isAzAccount={isAzAccount}
            corpOptions={corporationOptions}
            isMdAccount={isMdAccount}
          />
        );
      case FILTER_QUERY_BUILDER_TABS.VISITS_HISTORY:
        return <VisitsHistory />;
      default:
        return null;
    }
  };

  return (
    <Styled.Wrapper>
      {isLoading && <Loader />}
      <QueryBuilderContainer tabs={TABS} id="wrapper" activeTab={activeTab} setActiveTab={setActiveTab}>
        {displayContent()}
      </QueryBuilderContainer>
    </Styled.Wrapper>
  );
};
